import { cva } from '../tokens/variants';

export const avatarVariants = cva(
  'relative inline-flex shrink-0 select-none font-semibold text-white',
  {
    variants: {
      size: {
        xs: 'h-6 w-6 text-[10px]',
        sm: 'h-8 w-8 text-xs',
        md: 'h-10 w-10 text-sm',
        lg: 'h-12 w-12 text-base',
        xl: 'h-16 w-16 text-xl',
      },
      shape: {
        circle: '',
        rounded: '',
      },
    },
    defaultVariants: { size: 'md', shape: 'circle' },
  },
);

/** Eight stable gradient pairs. The avatar picks one based on a hash of the
 *  `seed` (or `name` if no seed is given). Same seed → same gradient, always.
 *  Tailwind v4 inlines these via `style={{background:...}}` so the gradients
 *  travel with the component without needing extra CSS. */
export const AVATAR_GRADIENTS = [
  'linear-gradient(135deg, #9D82FF, #5131CC)', // purple
  'linear-gradient(135deg, #5EEAD4, #0F766E)', // teal
  'linear-gradient(135deg, #FCD34D, #D97706)', // amber
  'linear-gradient(135deg, #FB7185, #BE123C)', // rose
  'linear-gradient(135deg, #60A5FA, #1D4ED8)', // blue
  'linear-gradient(135deg, #6EE7B7, #047857)', // emerald
  'linear-gradient(135deg, #C4B5FD, #6D28D9)', // violet
  'linear-gradient(135deg, #FDBA74, #C2410C)', // orange
] as const;

/** Stable hash → gradient index. Picked to be tiny + deterministic. */
export function pickGradient(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return AVATAR_GRADIENTS[h % AVATAR_GRADIENTS.length];
}

/** Up-to-2-character initials extracted from a name. */
export function initialsFromName(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}
